import React from 'react';

import { useSelector, useDispatch} from 'react-redux'

import './ConfirmationModal.css';

import store from 'Store';

import { dismissModal, startRequest, } from 'Store/features/stateSlice'

import logo from 'Assets/sad-newsie-192-removebg.png'
import { makeDeleteProfileRequest } from 'API/Profile';
import { REQUESTS } from 'Util/constants';
import { logout } from 'Store/features/authSlice';


const CONFIRMATION_MODAL_VARIANTS = {
  CONFIRM_USER_DELETE: {
    title: 'So, you want to delete your account?',
    confirmButtonText: 'yes',
    cancelButtonText: 'no',
    onConfirm: async (e, dispatch, authToken) => {
      e.stopPropagation();
      await makeDeleteProfileRequest(dispatch, authToken);
      dispatch(logout());
      dispatch(dismissModal());
    },
    onCancel: (e) => {
      e.stopPropagation();
      store.dispatch(dismissModal())
    },
    image: logo
  }
};

const ConfirmationModal = () => {
  const variant = useSelector(state => state.stateSlice.dynamicModalVariant);
  const authToken = useSelector(state => state.authSlice.authToken);
  const dispatch = useDispatch();

  const { title, confirmButtonText, cancelButtonText, onConfirm, onCancel, image } = CONFIRMATION_MODAL_VARIANTS[variant];

  return <div className='confirmation-modal-layout'>
    <div className='confirmation-modal-title-container'>
      <div className='confirmation-modal-title'>
        <strong>{title}</strong>
      </div>
    </div>
    <div className='confirmation-modal-image-container'>
      <img src={logo} />
    </div>

    <div className='confirmation-buttons-container'>
      <div className='confirmation-modal-button confirm' onClick={e => onConfirm(e, dispatch, authToken)}>
        <strong>{confirmButtonText}</strong>
      </div>
      <div className='confirmation-modal-button cancel' onClick={onCancel}>
        <strong>{cancelButtonText}</strong>
      </div>
    </div>

  </div>
}

export default ConfirmationModal